import { TranslationMessages } from 'ra-core';
import frenchMessages from 'ra-language-french';

const customFrenchMessages: TranslationMessages = {
    ...frenchMessages,
    global: {
        auth: {
            email: 'Email',
            sign_in: 'Entrer',
            password: 'Mot de Passe',
            sign_in_error: "Erreur d'Authentification Failed",
        },
    },
    pos: {
        search: 'Rechercher',
        configuration: 'Configuration',
        language: 'Langue',
        theme: {
            name: 'Theme',
            light: 'Clair',
            dark: 'Obscur',
        },
        dashboard: {
            subscriptions_today: {
                title: 'Nouveaux Clients',
                subtitle: "Aujourd'hui",
            },
            subscriptions_total: {
                title: 'Total Clients',
                subtitle: '',
            },
            courses_today: {
                title: 'Nouvelles Courses',
                subtitle: "Aujourd'hui",
            },
            courses_total: {
                title: 'Total courses',
                subtitle: '',
            },
            drivers_online: {
                title: 'Chaufeurs Connectés',
                subtitle: 'Actuellement',
            },
            welcome: {
                title: 'Bienvenue dans Livriris',
                subtitle: 'Ceci est le back-office Livriris..',
                aor_button: 'Site web de Livriris',
                demo_button: 'Code source de cette démo',
            },
        },
        menu: {
            sales: 'Ventes',
            prducts: 'Produits',
            users: 'Utilisateurs',
            delivery: 'Livraisons',
        },
        actions: {
            concel: 'Annuler',
        },
    },
    resources: {
        users: {
            name: 'Client |||| Clients',
            fields: {
                name: 'Nom Prénom',
                email: 'Email',
                phone: 'Tél',
                civility: 'Genre',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                birthdate: 'date de Naissance',
                socialReason: 'Raison Sociale',
                created_at: "Date d'inscription",
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
                nb_courses: 'N de Commandes',
            },
            civilities: {
                monsieur: 'M',
                madame: 'Mme',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                quizzes: 'Quizzes',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        VehiculeTypes: {
            name: 'Type de Véhicule |||| Types de Véhicules',
            fields: {
                name: 'Nom',
                image: 'Image',
                tarif_km: 'Prix sur chaque KM',
                tarif_min: 'Prix ​​à la minute',
                is_enabled: 'Activer', 
                created_at: 'Date de Création',
            },
        },
        drivers: {
            name: 'Chauffeur |||| Chauffeurs',
            fields: {
                name: {
                    first: 'Nom',
                    last: 'Prénom',
                    full: 'Nom Complet',
                },
                vehicle_type: 'Type de Véhicule',
                email: 'Email',
                commission: 'Commission en %',
                phone: 'Tél',
                civility: 'Genre',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                birthdate: 'date de Naissance',
                socialReason: 'Raison Sociale',
                created_at: "Date d'inscription",
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
                nb_courses: 'N de Commandes',
            },
            civilities: {
                monsieur: 'M',
                madame: 'Mme',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                quizzes: 'Quizzes',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le Chauffeur',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        admins: {
            name: 'Administrateur |||| Administrateurs',
            fields: {
                name: {
                    first: 'Prénom',
                    last: 'Nom',
                },
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                commands: 'Commandes',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        operators: {
            name: 'Opérateur |||| Opérateurs',
            fields: {
                name: {
                    first: 'Nom',
                    last: 'Prénom',
                    full: 'Nom Complet',
                },
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                commands: 'Commandes',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        banners: {
            name: 'Bannière |||| Bannières',
            fields: {
                name: 'Nom',
                image: 'Image',
                target: 'Cible',
                targetModel: 'Type',
                category: 'Catégorie',
                feature: 'Feature',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
        },
        courses: {
            name: 'Course |||| Courses',
            fields: {
                user: 'Client',
                code: 'Numéro',
                code_str: 'Numéro',
                from: 'De',
                from_address: "De l'adresse",
                to: 'Vers',
                to_address: "Vers l'adresse",
                driver: 'Chauffeur',
                notified_drivers: 'Chauffeurs notifiés',
                google_distance: 'Distance Estimée Google',
                google_duration: 'Durée Estimée Google',
                statut: 'Statut',
                client_note: 'Note client',
                client_comment: 'Commentaire clent',
                price: 'Prix Payé',
                estimated_price: 'Prix Estimé',
                created_at: 'Date de Création',
            },
            course_statut: {
                new: 'Nouvelle',
                in_search: 'En Recherche',
                driver_notified: 'En attente de Chauffeur',
                conceled_by_client: 'Abandonnée par Client',
                in_way: 'En route',
                conceled_by_driver: 'Abandonnée par Chauffeur',
                in_destination: 'En destination',
                accepted: 'Acceptée',
                in_place: 'Chauffeur sur place',
                started: 'Démarrée',
                finished: 'Terminée',
                payed: 'Payée',
                not_payed: 'Paiement échoué',
            },
            actions: {
                pay: 'Payer',
            },
        },
        course_events: {
            name: 'Evénement |||| Evénements',
            fields: {
                source: 'Déclanché par',
                to_statut: 'Statut',
                created_at: 'Date de Création',
            },
            source_types: {
                user: 'Client',
                driver: 'Chauffeur',
                operator: 'Opérateur',
                admin: 'Administrateur',
            },
        },
    },
};

export default customFrenchMessages;
